import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {SiteuserService} from '../services/siteuser.service';
import {CartService} from '../services/cart.service';
import { NgForm} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {environment as env} from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {LanguageService} from '../services/language.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  isloggedin:boolean;
  uname:string;
  totalcartItem : number;
  searchterm :string;
  ishamClicked:boolean;
  showLang:string;
  seletedAr:string;
  seletedEn:string;

  constructor(private usrObj:SiteuserService,
     private http:HttpClient, 
     private router:Router, 
     private cartObj:CartService,
     private langObj:LanguageService,
     public translate: TranslateService) { 
     translate.addLangs(['en', 'ar']);
     translate.setDefaultLang('en');
  
     const browserLang = translate.getBrowserLang();
     translate.use(browserLang.match(/en|ar/) ? browserLang : 'en');
     }

  ngOnInit(): void {
    this.seletedAr='';
    this.seletedEn = '';
    this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }
     this.translate.use(this.showLang);
     if(this.showLang == 'en'){
       this.seletedEn = 'selected';
     }
     if(this.showLang == 'ar'){
      this.seletedAr = 'selected';
    }

    var body = document.body;
    if (this.showLang == 'ar') {
      body.classList.add("arabic");
    } else {
      body.classList.remove("arabic");
    }

    var storedCart = JSON.parse(localStorage.getItem("cartData"));
    if(storedCart != null){
      this.totalcartItem = storedCart.length;
    }
    // Receive cart count data form service
    this.cartObj.cartCount.subscribe((cartcount:number)=>{
      this.totalcartItem = cartcount;
    })

    if(this.usrObj.loggedIn() == false){
      this.isloggedin = false;
    }else{
      this.isloggedin = true;
      this.uname = localStorage.getItem('sajuname');
    }
  }

  onsearchsubmit(frm:NgForm){
    this.searchterm = frm.value.searchtxt;
    this.router.navigate(['/search'], {queryParams:{term:this.searchterm}});
  }

  logout(){
    localStorage.removeItem('sajid');
    localStorage.removeItem('sajuname');
    localStorage.removeItem('sajtoken');
    this.router.navigate(['order-online']); 
  }

  useLanguage(language: string) { 
    this.showLang = language;
    var body = document.body;
    if(language == 'ar'){
      body.classList.add("arabic");
    }else{
      body.classList.remove("arabic");
    }

    
    localStorage.setItem("showLang", language);
    this.translate.use(language);
    this.langObj.langStr.emit(this.showLang);
  }

}
